import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgCloseSchedule = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 21"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M8.003 7.253a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5z" />
      <path d="M.25 16.006V5.5l.01-.274a3.748 3.748 0 0 1 2.204-3.141.75.75 0 0 1 .613 1.37A2.247 2.247 0 0 0 1.75 5.502v10.503a2.252 2.252 0 0 0 2.251 2.252h12.006c.596 0 1.17-.237 1.59-.66a.75.75 0 0 1 1.062 1.06 3.741 3.741 0 0 1-2.653 1.099H4A3.752 3.752 0 0 1 .25 16.007M18.258 13.005V5.502a2.252 2.252 0 0 0-2.252-2.251H6.002a.75.75 0 0 1 0-1.5h10.004a3.752 3.752 0 0 1 3.752 3.75v7.504a.75.75 0 0 1-1.5 0" />
      <path d="M13.755 4.001V1a.75.75 0 0 1 1.5 0v3.001a.75.75 0 0 1-1.5 0M19.008 7.253l.076.004a.75.75 0 0 1 0 1.492l-.076.004h-6.003a.75.75 0 0 1 0-1.5zM.47.47a.75.75 0 0 1 1.06 0l19.008 19.008a.75.75 0 1 1-1.06 1.06L.47 1.53a.75.75 0 0 1 0-1.06" />
    </svg>
  );
};
export default SvgCloseSchedule;
